import { Avatar, AvatarFallback, AvatarImage, getInitials } from './avatar';
import { AiAgentStar } from './ai-agent-star';
import { cn } from '../lib/cn';

export interface AgentNameProps {
  name: string | null | undefined;
  avatarUrl?: string | null;
  /** Explicit AI classification supplied by the caller. */
  isAi?: boolean;
  showAvatar?: boolean;
  /** Hide the visible name for avatar-only displays; keep it accessible. */
  showName?: boolean;
  size?: 'xs' | 'sm';
  className?: string;
  /** Shown when `name` is empty. */
  fallback?: string;
}

/** An agent's identity, with an explicit AI pill. Presentational only. */
export function AgentName({
  name,
  avatarUrl,
  isAi = false,
  showAvatar = true,
  showName = true,
  size = 'xs',
  className,
  fallback = 'Unknown',
}: AgentNameProps) {
  const label = name?.trim() || fallback;
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-2', className)}>
      {showAvatar ? (
        <Avatar size={size}>
          {avatarUrl ? <AvatarImage src={avatarUrl} alt="" /> : null}
          <AvatarFallback>{getInitials(name?.trim() || null)}</AvatarFallback>
        </Avatar>
      ) : null}
      <span className={showName ? 'min-w-0 truncate text-text-primary' : 'sr-only'}>{label}</span>
      {isAi ? <AiAgentStar /> : null}
    </span>
  );
}
